import React from "react";
import InfoIconLight from "../../assets/icons/InfoIconLight.svg";
import InfoIconDark from "../../assets/icons/InfoIconDark.svg";
import BackgroundImage from "../../assets/images/HomeImage.webp";
import "./Info.css";
import { strings } from "../../translations/strings";

const Info = ({ data }) => {
  const { colors, isDarkMode } = data;
  const items = [
    {
      title: strings.info_content_subtitle_one,
      text: strings.info_content_text_one,
    },
    {
      title: strings.info_content_subtitle_two,
      text: strings.info_content_text_two,
    },
    {
      title: strings.info_content_subtitle_three,
      text: strings.info_content_text_three,
    },
    {
      title: strings.info_content_subtitle_four,
      text: strings.info_content_text_four,
    },
    {
      title: strings.info_content_subtitle_five,
      text: strings.info_content_text_five,
    },
  ];
  return (
    <div className="info-container">
      <img
        alt="Background"
        src={BackgroundImage}
        className="info-background-image"
        draggable={false}
      />
      <div
        className="info-hairline"
        style={{ backgroundColor: colors.borderColor }}
      />
      <div
        className="info-content"
        style={{ backgroundColor: colors.componentBackground }}
      >
        <span className="info-title" style={{ color: colors.primaryText }}>
          {strings.info_title}
        </span>
        <span className="info-text" style={{ color: colors.secondaryText }}>
          {strings.info_text}
        </span>
        <img
          className="info-icon"
          alt="Info"
          src={isDarkMode ? InfoIconDark : InfoIconLight}
          draggable={false}
        />
        <span
          className="info-content-title"
          style={{ color: colors.primaryText }}
        >
          {strings.info_content_title}
        </span>
        {items?.map((item, index) => {
          return (
            <React.Fragment key={`${index}`}>
              <div className="info-horizontal-line" />
              <span
                className="info-item-title"
                style={{ color: colors.primaryText }}
              >
                {item?.title}
              </span>
              <span
                className="info-item-text"
                style={{ color: colors.secondaryText }}
              >
                {item?.text}
              </span>
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
};
export default Info;
